/**
 * Email addresses, as an owner's second way in.
 *
 * Kept deliberately simple. The only test that really proves an address is a
 * code arriving in it; this just catches what is obviously not one, so a typo
 * is pointed out before a code is sent nowhere.
 */

/** Something, an @, a domain with a dot, and no spaces. */
const SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Stored and compared lower-case: `Faadumo@Gmail.com` is `faadumo@gmail.com`. */
export function normalizeEmail(input: string): string | null {
  const email = input.trim().toLowerCase();
  return email.length <= 254 && SHAPE.test(email) ? email : null;
}

export function isValidEmail(input: string): boolean {
  return normalizeEmail(input) !== null;
}

/**
 * Shown back after a code is sent, so a mistyped address is obvious without
 * showing the whole of it on a screen somebody may be looking over:
 * `faadumo.ali@gmail.com` → `fa*********@gmail.com`.
 */
export function maskEmail(email: string): string {
  const at = email.lastIndexOf("@");
  if (at < 1) return email;
  const name = email.slice(0, at);
  const keep = name.length <= 2 ? 1 : 2;
  return `${name.slice(0, keep)}${"*".repeat(Math.max(1, name.length - keep))}${email.slice(at)}`;
}

/**
 * Whether what somebody typed in a "phone number or email" box is meant as an
 * email. An @ decides it: a phone number never has one.
 */
export function looksLikeEmail(input: string): boolean {
  return input.includes("@");
}
